import { USER_ROLE } from '../enums';

export const AUTHORITY_ROLE_WITH_ACCESS_BASIC: USER_ROLE[] = [
  USER_ROLE.ADMIN,
  USER_ROLE.OWNER,
  USER_ROLE.USER_LITE_PLUS,
  USER_ROLE.USER_LITE,
];
export const AUTHORITY_ROLE_WITH_ACCESS_PLUS: USER_ROLE[] = [
  USER_ROLE.ADMIN,
  USER_ROLE.OWNER,
  USER_ROLE.USER_LITE_PLUS,
];
export const AUTHORITY_ROLE_WITH_FULL_ACCESS: USER_ROLE[] = [
  USER_ROLE.ADMIN,
  USER_ROLE.OWNER,
];
